import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, BACKEND_URL } from "@/lib/api";
import { applyAccent, applyBranding, applyMode } from "@/lib/theme";

const SettingsCtx = createContext(null);
const MODE_KEY = "ksp_theme";

const DEFAULTS = { app_name: "Koperasi Simpan Pinjam", pwa_name: "KSP Mobile", accent: "emerald", dark_default: false, hidden_menus: [], logo_url: null, favicon_url: null, version: "0" };

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(DEFAULTS);
  const [dark, setDark] = useState(() => localStorage.getItem(MODE_KEY) === "dark");

  const apply = useCallback((s) => {
    setSettings(s);
    applyAccent(s.accent);
    applyBranding(s, BACKEND_URL);
    const pref = localStorage.getItem(MODE_KEY);
    const d = pref ? pref === "dark" : s.dark_default;
    setDark(d);
    applyMode(d);
  }, []);

  const reload = useCallback(async () => {
    try {
      const { data } = await api.get("/settings/public");
      apply(data);
    } catch {
      apply(DEFAULTS);
    }
  }, [apply]);

  useEffect(() => {
    reload();
  }, [reload]);

  const toggleMode = () => {
    const d = !dark;
    localStorage.setItem(MODE_KEY, d ? "dark" : "light");
    setDark(d);
    applyMode(d);
  };

  return (
    <SettingsCtx.Provider value={{ settings, apply, reload, dark, toggleMode, logoSrc: settings.logo_url ? `${BACKEND_URL}${settings.logo_url}` : null }}>
      {children}
    </SettingsCtx.Provider>
  );
};

export const useSettings = () => useContext(SettingsCtx);
